import { render, staticRenderFns } from "./rangeForm.vue?vue&type=template&id=989c76ae&scoped=true&"
import script from "./rangeForm.vue?vue&type=script&lang=tsx&"
export * from "./rangeForm.vue?vue&type=script&lang=tsx&"
import style0 from "./rangeForm.vue?vue&type=style&index=0&id=989c76ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989c76ae",
  null
  
)

export default component.exports